<template>
	<el-container id="index">
		<el-dialog title="签到成功" class="sign_dialog" :visible.sync="sign_dialog">
			<img :src='global.oss_website+"/pc/images/sign/sign_bg.jpg"' class="sign_bg">
			<i class="iconfont" @click="sign_dialog = false">&#xe61f;</i>
			<div class="sign_dialog_con">
				<p class="sign_title">{{ sign_title }}</p>
				<p class="sign_time">签到时间：{{sign_time_text}}</p>
				<img :src='global.oss_website+"/pc/images/sign/icon.png"' class="icon">
				<div class="sign_info">
					<p class="tips_tit">观看直播</p>
					<div class="douyin_box">
						<div class="img_box">
							<img :src="global.oss_website+now_live.qr_code">
						</div>
						<p class="operating_tips">打开{{pingtai}}<br>扫一扫观看直播</p>
					</div>
					<div class="password_box">
						<div class="password_con">{{now_live.key}}</div>
						<p class="operating_tips">复制口令<br>手机打开{{pingtai}}APP观看</p>
					</div>
				</div>
			</div>
		</el-dialog>

		<el-dialog
			title="超前提示"
			:visible.sync="popup_visible"
			width="410px"
			 class="popup_visible"
			>
			<div class="popup_visible_con">
				<i class="iconfont">&#xe614;</i>
				<div class="popup_visible_txt">
					<div>同学你好，第{{qiZh(max_term_open_info.term)}}学期课程已为你提前开通，您现在可以提前开始学习！</div>
				</div>
			</div>
			
			<span slot="footer" class="dialog-footer" style="text-align: center;">
			  <el-button type="primary" @click="no_reminder">确定</el-button>
			</span>
		</el-dialog>
		<p class="website_tips" v-if="website_tips">{{website_tips}}</p>
		<div class="leftBox" v-loading='uinfo_load'>
			<div class="ulogoBox">
				<el-image :src="ulogo">
					<div slot="error" class="image-slot">
						<el-image :src="defaUlogo"></el-image>
					</div>
				</el-image>
			</div>
			<div class="uinfo">
				<div class="uname">
					<h2>{{uname}}</h2>
					<p class="school">{{school}}</p>
					<p class="zy">{{zhuanye}}<span v-if="zhiyeCon">（{{cengci}}）</span></p>
				</div>
				<div class="ustudy">
					<h2>学习进度</h2>
					<div class="courseSt">
						<div class="cou zong"><p>总课程数</p><h3><font>{{mould_course_count}}</font>门</h3></div>
						<div class="cou guo" v-if="hideType === 3"><p>已通过课程数</p><h3><font>{{course_progress}}</font>门</h3></div>
					</div>
				</div>
			</div>
			<!-- &&!$store.state.research_institute -->
			<div class="switchCourse" v-if="courseSwShow" @click="courseSwClick">
				切换课程<i class="iconfont">&#xe68c;</i>
			</div>
			<div class="feedback" v-if="help">
				<div v-if="help.feedback_phone" class="feedback_phone">反馈电话：{{help.feedback_phone}}</div>
				<div v-if="help.feedback_email" class="feedback_email">反馈邮箱：{{help.feedback_email}}</div>
			</div>
		</div>
			<!-- <component ref="view"
				:course="courseData"
				v-if="courseData"
				:cInfo="courseInfoData"
				:userIndex="userIndexData"
				@jump="jumpFn($event)" v-bind:is="viewName"></component> -->
		<div class="live" v-loading="live_loading" v-if="live_list.live_data.length!=0 && temp.live_list">
			<div class="titBox">
				<p class="tit">直播签到
					<!-- <font class="tit_tips">直播前15分钟开放签到</font> -->
					<!-- <a href="">查看更多></a> -->
					<!-- <font class=""></font> -->
				</p>
				<div class="titRightBox">
					<el-link type="primary" class="see_more" @click="see_more">查看更多></el-link>
				</div>
				<!-- <a href="#" class="more">更多</a> -->
			</div>
			<el-carousel v-if="live_list.live_data.length>0" trigger="click" arrow="always" :autoplay="false"
			 :initial-index="live_list.now_live_page" @change="live_page_change">
				<el-carousel-item v-for="(item,index) in live_list.live_data" :key="index">
					<ul class="live_ul">
						<li v-for="(live_item,index) in item" :key="index" :class="condition_class(live_item)">
							<font class="condition">{{live_item.condition}}</font>
							<font class="sign_start">{{live_item.start_time.slice(0,live_item.start_time.length-3)}}</font>
							<img class="live_cover" :src="live_item.cover == '----' ? pictureUrl:global.oss_website+live_item.cover">
							<div class="live_info">
								<p class="live_tit" :title="live_item.title">{{live_item.title}}</p>
								<p class="live_teacher">讲师：{{live_item.lecturer}}</p>
								<div class="sign" :class="is_sign(live_item,'class')" @click="sign_fn(live_item)">{{is_sign(live_item,'text')}}</div>
							</div>
						</li>
					</ul>
				</el-carousel-item>
			</el-carousel>
			<p v-else class="no_data">暂无直播数据</p>
		</div>
		<div class="zuijin" v-if="history_show">
			<div class="titBox">
				<p class="tit">最近学习</p>
				<!-- <a href="#" class="more">更多</a> -->
			</div>
			<ul class="zui" v-loading="history_load">
				<li v-for="(item,i) in historyList" :key="i" v-if="i<4" @click="courseClick(item, 'history')">
					<div class="coverbox">
						<div class="course_type" v-if="item.course_type&&(hideType===3||hideType===4)">{{item.course_type_format}}</div>
						<img v-if="item.thumb && item.thumb != '-' && item.thumb != 1" :src="global.oss_website+item.thumb">
						<div class="courseImgContent" v-else>{{item.title}}</div>
						<!-- <p class="complete" :class="item.jinStart==item.jinEnd?'y':''">{{item.jinStart==item.jinEnd?"已完成":"未完成"}}</p> -->
					</div>
					<div class="courseTitBox" :title="item.title">{{item.title}}</div>
				</li>
			</ul>
		</div>
		<div class="kecheng">
			<div class="titBox">
				<p class="tit">我的课程 
					<span class="typesetting_tab" v-if="courseList_type===1">
						<i class="iconfont" :class="horizontal?'':'this_icon'" @click="horizontal=false">&#xe602;</i>
						<i class="iconfont" :class="horizontal?'this_icon':''" @click="horizontal=true">&#xe601;</i>
					</span>
				</p>
				<div class="titRightBox">
					<ul class="qi" :class="$store.state.qiFocus" @click.stop="qiClick($event)" v-if="hideType === 3">
						<i class="iconfont">&#xe610;</i>
						<!-- <li @click.stop="qiClick(-1)" :class="qiNum==0?'act':''">全部学期</li> -->
						<li v-for="(index,i) of qiData" :key="i" @click.stop="qiClick(i)" :class="qiNumClass(i)">第{{qiZh(index)}}学期{{qiDang==i?"（当前学期）":""}}</li>
					</ul>
				</div>
				<div class="class_time" v-if="schedules_obj[userQiNum]">上课时间：{{schedules_obj_txt(schedules_obj[userQiNum])}}</div>
			</div>
			<ul class="cs" :class="courseList_type==2?'group':(horizontal?'horizontal_typesetting':'')" v-if="courseList.length>0" v-loading="loading">
				<li v-for="(item,i) in courseList" :key="i" v-if="courseList_type===1" @click="courseClick(item)" >
					<div class="courseImgBox">
						<div class="course_type" v-if="item.course_type&&(hideType===3||hideType===4)">{{item.course_type_format}}</div>
						<img v-if="item.course.thumb && item.course.thumb != '-' && item.course.thumb != '1'" :src="global.oss_website+item.course.thumb">
						<div class="courseImgContent" v-else>{{item.course.title}}</div>
					</div>
					<div class="courseCon">
						<div class="pause_prompt" v-if="item.status==2">更新中，暂停学习</div>
						<h2>{{item.course.title}}</h2>
						<div class="couConLeft" v-if="hideType === 3">
							<div class="jin">
								<p class="jtit">平时成绩</p>
								<p class="jcon">{{score_res(item.course_result.score1)}}</p>
							</div>
							<div class="jin">
								<p class="jtit">期末成绩</p>
								<p class="jcon">{{score_res(item.course_result.score2)}}</p>
							</div>
							<div class="jin">
								<p class="jtit">总评成绩</p>
								<p class="jcon">{{score_res(item.course_result.score3)}}</p>
							</div>
							<!-- <el-progress :percentage="classChapter(item.total_score, item.total)" :stroke-width="10" :color="color"></el-progress> -->
						</div>
						<span class="xuexiBtn">进入学习</span>
					</div>
				</li>
				<li v-for="(item,i) in courseList" :key="i" v-if="courseList_type===2" >
					<div class="courseImgBox">
						<img v-if="item.cover_url != ''" :src="global.oss_website+item.cover_url">
						<div class="courseImgContent" v-else>{{item.title}}</div>
					</div>
					<dl class="courseGroup">
						<h2>{{item.title}}</h2>
						<dd v-for="(gitem, index) in item.course_rels" :key="index">
							<i class="iconfont">&#xe698;</i>
							<p class="courseGroup_tit">{{gitem.title}}</p>
							<span class="xuexiBtn" :class="xuexiBtnClass(gitem)" @click="courseClick(gitem, 'group')">{{join_study(gitem)}}</span>
						</dd>							
					</dl>
				</li>
			</ul>
			<div v-else-if="!loading" class="nodata">
				<img :src="nodataImg">
				<p>暂无课程</p>
			</div>
		</div>
	</el-container>
</template>

<script>
export default {
	name: 'index'
	,data () {
		return {
      		temp: this.temp.index,
			live_loading: false,
			pingtai:'',
			defaUlogo:'',
			headCom:"headView"
			,footerCom:"footerView"
			,courseSwShow:false			//切换课程是否显示
			,zhiyeCon: true
			// ,hideType: ''
			,grade_id:this.$store.state.grade_id
			
			,ulogo:''
			,uinfo_load:true
			,uname:"姓名"
			,school:"学校"
			,zhuanye:"专业"
			,cengci:"层次"
			,mould_course_count:0
			,course_progress:0

			,live_list:{
				live_data:[],
				now_live_page:0,
			}
			,sign_dialog: false
			,sign_title: '恭喜你签到成功'
			,sign_time_text: ''
			,now_live:{
				qr_code:''
				,key:''
			}

			// ,courseData:false			//课程列表页数据
			// ,courseInfoData:{}		//课程详情页数据
			// ,userIndexData:{}		//个人信息首页数据

			
			,color:"#5777fe"
			,loading:true

			// ,qiNum:0
			,userQiNum:0
			,qiDang:0
			,qiData:0		//["第一学期","第二学期","第三学期","第四学期"]

			,historyList:""
			,history_load:true
			,history_show:false

			,courseList:""

			,horizontal:true	//排版
			,courseList_type:""
			,popup_visible:false //新消息弹窗
			,notify_total:0
			// ,course_type_obj:{ //课程类型
			// 	1:'必考',
			// 	2:'选考',
			// 	3:'加考',
			// 	4:'必修',
			// 	5:'选修'
			// },
			,max_term_open_info:{
				term: 0,
			},
			schedules_obj:{},
			help:'',		// 反馈联系方式
			website_tips: '',		// 网站公告
			is_study_time:true,     //是否处于学习时间
		}
	}
	,created(){
		// let that = this
	}
	,mounted:function(){
		let that=this
			,serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui
		// console.log(this.host);
		//获取直播数据
		this.get_live_broadcast()

		//消息弹窗通知
		this.get_notify_total()

		//记录布局
		this.$store.commit("change_vuex",{
			key:"layout",
			value:0
		})

		//动态设置内容高度 让footer始终居底
		this.$emit("chMinHeight", document.documentElement.clientHeight - 188)

		this.$emit("swmuban",true);		//修改app.vue 的 muban_bol 值
		this.defaUlogo = this.global.oss_website+'/pc/images/ulogo.jpg';
		this.pictureUrl = this.global.oss_website+'/pc/images/course/courseImg.jpg';
		this.token=this.$cookies.get("token")

		this.$selfjs.getIdentityCallFn(this,function(resData){
			let identity_data = resData
			if(resData.length>1){
				that.courseSwShow = true
			}

			//获取用户数据
			let grade = that.$store.state.grade_id
				,url = serverSrc + qianzui + '/member/detail';
			that.$ajax.get(url)
			.then(function(res){
				let resData=res.data;
				if(resData.code==0){
					// console.log(resData.data)
					// that.global.uDetailData=resData.data;
					let ceng='';
					that.ulogo=resData.data.avatar						//用户头像
					that.uname=resData.data.nick_name					//用户名
					that.school=resData.data.school.school_name			//学校名称
					that.help=resData.data.school.extra.help			// 反馈联系方式
					that.website_tips=resData.data.school.extra.system.site_notice			// 网站公告
					that.zhuanye=resData.data.major.major_name			//专业名称
					that.cengci=that.$store.state.const.major_level.find(v=>{ return v.id == resData.data.major.major_level}).value		//层级
					that.mould_course_count=resData.data.mould_course_count			//课程总数
					that.course_progress=resData.data.course_progress				//课程进度
					that.qiData = resData.data.term_count		//学期数
					that.qiDang = resData.data.term-1				//当前学期
					that.userQiNum = resData.data.term		//当前学期数
					that.max_term_open_info = resData.data.max_term_open_info		// 最大学期信息
					// 如果已经缓存了超前数 且 新的超前数大于旧超前数 则 重置缓存值
					if(that.max_term_open_info.term > localStorage.max_term_open){
						delete localStorage.max_term_open
					}
					for (let i = 0; i < resData.data.grade.schedules.length; i++) {
						let obj = resData.data.grade.schedules[i]
						that.schedules_obj[obj.term] = obj
					}
					// console.log(resData);
					// if (resData.data.grade.cur_schedule) {
					// 	if ((Date.parse(resData.data.grade.cur_schedule.end_date)+86400000<Date.parse(new Date()))||Date.parse(resData.data.grade.cur_schedule.start_date)>Date.parse(new Date())) {
					// 		that.is_study_time = false
					// 	}
					// }
					// console.log(that.schedules_obj);
					// that.$ajax.get(serverSrc + qianzui + '/password/password_expire_check').then(function(res){
					// 	let resData = res.data.data
					// 	if (!(resData.is_expire==1)) {
					// 		if(localStorage.max_term_popup != 'false'
					// 		 && that.max_term_open_info.term > resData.data.term
					// 		 && localStorage.max_term_open == undefined){
							
					// 			that.popup_visible = true					// 打开弹窗
					// 			localStorage.max_term_popup = false			// 记录该账号登录后已弹出过一次
					// 		}
					// 		// that.dialogFormVisible = true
					// 		// that.$message.error('密码过期！请重置密码！');
					// 	}else{
					// 	}
					// })

					

					// let cookschool_logo = that.$cookies.get("school_logo");
					// if(!cookschool_logo){
						that.$store.commit("change_vuex",{
							key:"school_id",
							value:resData.data.school.school_id
						})
						that.$store.commit("change_vuex",{
							key:"major_level",
							value:resData.data.major.major_level
						})
						// console.log(resData.data.grade.grade_id);
						that.$store.commit("change_vuex",{
    					    key:"grade_id",
    					    value:resData.data.grade.grade_id
    					})
						that.$store.commit("change_vuex",{
							key:"mould_id",
							value:resData.data.grade.mould_id
						})
						grade = resData.data.grade.grade_id
						// that.$store.state.grade_id = resData.data.grade.grade_id
						// console.log(that.$store.state);
						//获取最近学习课程
						let history_url = serverSrc + qianzui + "/member/courses/history"
						that.$ajax.get(
							history_url
							,{
								params:{
									page:1
									,page_size:4
									,grade_id:grade
								}
							})
						.then(function(res){
							let resData=res.data;
							if(resData.code==0){
								that.historyList=resData.data.data;
								that.history_load=false;
								that.history_show=true;
							}else if(resData.code==401){
								that.$message.error('请求错误');
							}else{
								that.history_show=false;
								console.log(resData.message);
							}
						})
					// }
					that.uinfo_load=false;

					//获取当前身份，判断显示的模板
					let identity = parseInt(resData.data.identity[0].id || that.$cookies.get("identity"))
						,defaObj = identity_data[0]
					for(let i in identity_data){
						if(identity_data[i].id == identity){
							defaObj = identity_data[i]
						}
					}
					that.$selfjs.idswitch(that,defaObj)
				}
			})

		})
	}
	,methods:{	
		//获取直播数据
		get_live_broadcast(){
			this.live_loading = true
			let url = this.global.serverSrc + this.global.qianzui + "/live_broadcast/list"
			//获取80条已结束的数据
			this.$ajax.get(
				url
				,{
					params:{
						page:1
						,page_size:80
						// ,is_end:1
					}
				})
			.then(res=>{
				this.live_loading = false
				let resData=res.data
				if(resData.code==0){
					let arr_idx = -1
					resData.data.data.map((item, index, arr)=>{
						if(index % 4 == 0){
							this.live_list.live_data.push([])
							arr_idx++
						}
						this.live_list.live_data[arr_idx].push( item )
					})
				}
			})
			
		},
		//直播状态样式判断
		condition_class(item){
			let res = ''
			switch(item.condition){
				case "未开始":
					res = 'not'
					break;
				case "直播中":
					res = 'ing'
					break;
				case "已结束":
					res = ''
					break;
			}
			return res
		},
		//直播查看更多
		see_more(){
			this.$router.push({
				path: '/web/live/list',
				name: 'live_broadcast',
				// query: {courseId: this.cInfo.courseId, test_id: scope.row.test_id},
				// params: ''
			})
		},
		//直播翻页
		live_page_change(index){
			// this.live_list.live_page = index+1
			// this.live_list.loading = true
			// this.get_live_broadcast()
		},
		//点击签到
		addzero(time){
			let res = time
			if(time<10){
				res = '0'+time
			}
			return res
		},
		sign_fn(item){
			let that =this
			// 判断直播平台是否为学习平台
			if(item.platform == 3){
				this.$emit('jump',['/web/live/room', 'live_room', {id: item.id, live_id: item.live.id, room_num: item.live.room_num}])
				return true
			}
			that.live_list.loading = true
			//用户签到
			let url = this.global.serverSrc + this.global.qianzui + "/live_broadcast/add_sign"
			this.$ajax.post(
				url,
				that.$qs.stringify({
					id: item.id
				}))
			.then(function(res){
				that.live_list.loading = false
				let resData=res.data;
				if(resData.code==0){	
					if(resData.data.created_at){
						that.pingtai=(item.platform==1?'抖音':'企业微信')
						that.sign_title = resData.message
						//签到时间时间
						that.sign_time_text = resData.data.created_at
					}else{
						that.pingtai=(item.platform==1?'抖音':'企业微信')
						//计算当前时间
						let d = new Date()
							,day = `${d.getFullYear()}-${that.addzero(d.getMonth() + 1)}-${that.addzero(d.getDate())} `
							,time = `${that.addzero(d.getHours())}:${that.addzero(d.getMinutes())}:${that.addzero(d.getSeconds())}`
						that.sign_time_text = day + time
					}
				}else if(resData.code==1 || resData.code==2 || resData.code==3){
					//2：超过签到时间、3：未到签到时间
					that.$message.error(resData.message);
					return false;
				}
				//显示签到成功弹窗
				that.sign_dialog = true
				//绑定对应的数据
				that.now_live = item
				//绑定数据
				that.get_live_broadcast()
			})
		},
		//是否签到文字及样式返回
		is_sign(item, type){
			let clas = "",
				text = "",
				res
			let sign_start = new Date(Date.parse(item.sign_start.replace(/-/g,'/')))
				,sign_end = Date.parse(new Date(item.sign_end.replace(/-/g,'/')))
				,now_date = Date.parse(new Date())
			//现在时间 大于 签到开始时间 且 现在时间 大于 签到结束时间 且 为未签到状态
			if(now_date > sign_start && now_date < sign_end && item.is_sign == 0){
				clas = 'act'
			}else{
				clas = ''
			}

			if(item.is_sign == 0){
				if(sign_end < now_date){
					text = '未签到'
				}else{
					text = item.platform == 3 ? '观看直播':'签到'
				}
			}else{
				text = item.platform == 3 ? '观看直播':'已签到'
			}
			if(type == "class"){
				res = clas
			}else if(type == "text"){
				res = text
			}
			return res
		},
		//课程点击
		courseClick(item, type){
			if (type=='history'&&item.mould_course.status==2) {
				this.$message.warning('更新中，暂停学习');
				return false
			}
			if (!type&&item.status==2) {
				this.$message.warning('更新中，暂停学习');
				return false
			}
			// 判断课程组的课程是否处于可学习状态
			if(type == "group" && this.study_status(item) != 1){
				return false
			}
			const loading = this.$loading({
        	  	lock: true,
        	  	text: 'Loading',
        	  	spinner: 'el-icon-loading',
        	  	background: 'rgba(0, 0, 0, 0.7)'
        	});
			let serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui
			this.$ajax.get(serverSrc + qianzui +"/member/check_course_can_study?course_id="+(type == 'history'?item.id:item.course.id))
			.then((res)=>{
				loading.close();
				let resData=res.data;
				if(resData.code==0){
					if (resData.data.result==2) {
						this.$message.warning("当前不在学习时间")
						return false
					}
					let that = this,
						historyType = true,
						courseId = 0,
						judgment
					let term = that.qiDang + 1
					if(type == 'history'){
						for(let h=0;h<item.mould_course.length;h++){
							if(term >= item.mould_course[h].term){
								break;
							}
							if(item.mould_course.length == (h+1) ){
								historyType = false
							}
						}
						courseId = item.id
						judgment = historyType
					}else{
						courseId = item.course.id
						judgment = this.userQiNum <= this.max_term_open_info.term
					}
				
					if( judgment ){
						that.$emit('jump',['/web/courseInfo/', 'courseInfo', {courseId: courseId}, {}])
					}else{
						that.$message.error("当前学期未开学！")
					}
				}else{
					this.$message.error(resData.message)
					// console.log(resData.message);
				}
			})
			// if (!this.is_study_time) {
			// 	this.$message.warning("当前不在学习时间")
			// 	return false
			// }
		},
		//学期中文字返回
		qiZh(i){
			return this.$selfjs.qiZh(i)
		},
		//课程进度计算
		classChapter(start, end){
			let progress = 0
			if(start != 0){
				progress = parseInt((start/end)*100)
			}
			return progress
		},
		//学习时间
		schedules_obj_txt(obj){
			return obj.start_date.replace(/-/g,'.') + ' - ' +obj.end_date.replace(/-/g,'.')
		},
		//学期选择点击
		qiClick(num){
			var that=this
			this.$selfjs.qiSelect(this,{num:num}, function(option){
				let clickNum = option.num+1
				// 判断userQiNum是否有改变
				if(that.userQiNum == clickNum){
					return false
				}
				that.userQiNum = clickNum
				if (that.userQiNum>that.qiDang+1) {
					that.$message.warning('课程未到学习时间');
				}
				that.loading=true
				
				//设置空白课程
				that.courseList=[{
						course: {
							thumb: "-",
							title: "",
						},
						course_chapter_count: 0,
						course_id: 0,
						course_program: 0,
						course_type: 0,
						self_result: 0,
						class_result: 100,
						total_score:0,
						course_result:{
							score1:0,
							score2:0,
							score3:0,
						}
					},{
						course: {
							thumb: "-",
							title: "",
						},
						course_chapter_count: 0,
						course_id: 0,
						course_program: 0,
						course_type: 0,
						self_result: 0,
						class_result: 100,
						total_score:0,
						course_result:{
							score1:0,
							score2:0,
							score3:0,
						}
					}
				]
				//获取用户课程列表
				// let courses_url = that.global.serverSrc + that.global.qianzui + "/member/courses"
				// that.$ajax.get(
				// 	courses_url
				// 	,{
				// 		params:{
				// 			term:option.num+1
				// 		}
				// 	})
				// .then(function(res){
				// 	let resData=res.data;
				// 		that.courseList=resData.data.data
				// 		that.loading=false;
				// })
			})
		},
		//切换课程点击
		courseSwClick(){
			//记录布局
			this.$store.commit("change_vuex",{
				key:"layout",
				value:1
			})
			this.$emit('jump',['/web/range/', 'range'])
		},
		// 学期样式计算
		qiNumClass(i){
			return (this.qiNum-1) == i ? 'act' : ''
		},
		score_res(score){
			let val = score
			if(score == 0){
				val = '-'
			}
			return val
		},
		// 课程组课程可学习状态判断
		study_status(gitem){
			let st = 1
			// 开始时间 大于 当前时间
			if(new Date(gitem.publish_time) > new Date() ){
				st = 2
			}
			// 当前时间 大于 结束时间
			if(new Date() > new Date(gitem.expire_time)){
				st = 3
			}
			return st
		},
		// 进入学习文字输出
		join_study(gitem){
			let val = '-'
			switch(this.study_status(gitem)){
				case 1:
					val = '进入学习'
					break;
				case 2:
					val = '即将上线'
					break;
				case 3:
					val = '已过期'
					break;
			}
			return val
		},
		xuexiBtnClass(gitem){
			let resVal = ''
			if(this.study_status(gitem) == 1){
				resVal = 'show'
			}
			return resVal
		},
		//新通知消息条数
		get_notify_total(){
			let url = this.global.serverSrc+this.global.qianzui+'/notify/notifyTotal';
			let token=this.$cookies.get("token")
			this.$ajax.get(url)
			.then((res)=>{
				if (res.data.data!=0) {
					if (localStorage.message_popup=='true') {
						this.$notify.info({
							title: '新消息提示',
							message: `你有${res.data.data}条，未读新消息！<b style="color:#f00">点击查看</b>`,
							dangerouslyUseHTMLString: true,
							duration: 0,
							customClass: 'newMessagePopup',
							onClick: ()=>{
								this.look_notify()
								this.$notify.closeAll()
							}
						});
						localStorage.message_popup = 'false'
					}
				}
			})
		},
		//跳转消息通知
		look_notify(){
			this.$selfjs.swhead(this,'notify');
			this.$store.commit("activeIndex", 'notify')	//初始化导航值
			this.$selfjs.jumpPage(this, {
				title:"消息通知",
				router:"/web/notify/",
				name: 'notify',
				query:{page:'notify'}
			})
		},
		// 下次登录不再弹出
		no_reminder(){
			this.popup_visible = false
			localStorage.max_term_open = this.max_term_open_info.term
		},
	}
	,computed:{
		//根据身份隐藏内容
		hideType(){
			let hideType = parseInt(this.$store.state.hideType)
			this.zhiyeCon = (hideType === 9 || hideType === 10) ? false : true
			return hideType
		},
		qiNum(){
			let that = this
				,userQiNum = this.userQiNum
			if(userQiNum == 0){
				return false
			}
			// if(this.hideType === 0){
			// 	userQiNum = 0
			// }
			// console.log(hideType, userQiNum)
			if(that.token){
				//获取用户课程列表
				let courses_url = this.global.serverSrc + this.global.qianzui + "/member/courses"
				this.$ajax.get(
					courses_url
					,{
						params:{
							term:userQiNum
							,pagsize:999
						}
					})
				.then(function(res){
					let resData=res.data;
					if(resData.code==0){
						// console.log(resData.data.data);
						that.courseList=resData.data.data
						that.courseList_type = resData.data.course_type
						that.loading=false;
					}
				})
			}
			return userQiNum
		}
		,userDetail(){

		}
	}
	,watch:{
		qiNum:{
			handler (newValue, oldValue) {
				// let that = this
				// console.log(newValue,oldValue)
			},
			deep: true
		}
		,grade_id:{
			handler (newValue, oldValue) {
				// let that = this
				console.log(newValue,oldValue)
			},
			deep: true
		}
	}
	// ,components:{
	// 	course
	// 	,courseInfo
	// 	,xiaozuPage
	// 	,kaoshiPage
	// 	,kebiaoPage
	// 	,zuoyePage
	// 	,chengjiPage
	// 	,bijiPage
	// 	,tongjiPage
	// 	,userIndexPage
	// }
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
#index{background:#f4f4f4;display:block;}
</style>


// WEBPACK FOOTER //
// src/components/index.vue